import $ from 'jquery';
import { isMobile, throttle } from './utils';

var Menu = {
  fixedHeader : null,
  dropdowns   : null,

  init: function() {
    if(isMobile()) {
      this.dropdowns = $('.dropdown > a');

      this.dropdowns
        .off('click')
        .on('click', this.toggleDropdown);
    } else {
      this.fixedHeader = $('#fixed-header');
      this.dropdowns = $('.dropdown');

      $(window).on('scroll', throttle(this.toggleFixed, 100));

      this.dropdowns
        .off('click mouseenter mouseleave')
        .on('mouseenter', this.showDropdown)
        .on('mouseleave', this.hideDropdown);
    }
  },

  toggleFixed: function() {
    var posY = $(window).scrollTop();
    var isVisible = Menu.fixedHeader.is(':visible');

    if(posY > 106) {
      if(!isVisible) {
        Menu.fixedHeader.stop().fadeIn(300);
      }
    } else {
      Menu.fixedHeader.stop().hide();
    }
  },

  showDropdown: function(e) {
    var self = $(this);
    self.addClass('open');
    self.attr('aria-expanded', 'true');
  },

  hideDropdown: function(e) {
    var self = $(this);
    self.removeClass('open');
    self.attr('aria-expanded', 'false');
  },

  toggleDropdown: function(e) {
    e.preventDefault();

    var self = $(this);
    var parent = self.parent();
    parent.toggleClass('open');

    if(parent.attr('aria-expanded') == 'false') {
      parent.attr('aria-expanded', 'true');
    } else {
      parent.attr('aria-expanded', 'false');
    }
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/menu.js